/*
 * @Author: wangcq01
 * @LastEditors: wangcq01
 * @Date: 2020-04-02 10:33:21
 * @LastEditTime: 2020-04-08 16:52:37
 * @FilePath: \dmp-web-v2\src\components\showMessageBox.js
 * @Description: 模块
 */
import React from 'react'
import { Modal } from 'antd'
import _ from 'lodash'
import './showMessageBox.less'

const MIN_HEIGHT = 124
const MAX_HEIGHT = 600
const PADDING_HEIGHT = 44 + 16 + 16

const getContent = (str) => {
  return str.split('\n').map((item, idx) => (<p key={idx} className='item-content'>{item}</p>))
}

const showMessageBox = (content, options) => {
  options = options || { env: '' }
  
  let getContainer = document.body
  let centered = true
  let paddingTmp = 0
  if (options.env === 'designTime') {
    getContainer = document.getElementById('designer_content')
    centered = false
  }
  if (options.env === 'previewDetail') {
    getContainer = document.getElementById('chart-detail-container')
    centered = true
  }
  if (options.env === 'preview') {
    getContainer = document.querySelector('.phone-wrap')
    centered = true
    paddingTmp = 48
  }
  
  const { offsetWidth, offsetHeight } = getContainer || {}
  const isLandscape = offsetWidth > offsetHeight // 横屏
  let width
  let maxHeight
  if (!isLandscape) {
    width = offsetWidth - (24 * 2)
    maxHeight = offsetHeight - (200 * 2)
  } else {
    width = offsetWidth - (160 * 2)
    maxHeight = offsetHeight - (84 * 2)
  }
  width -= paddingTmp

  if (maxHeight < MIN_HEIGHT) {
    maxHeight = MIN_HEIGHT
  }
  if (maxHeight > MAX_HEIGHT) {
    maxHeight = MAX_HEIGHT
  }
  maxHeight -= PADDING_HEIGHT

  if (options.env === 'designTime') {
    width = 500 - (24 * 2)
  }
  if (_.isString(content)) {
    content = {
      content
    }
  }
  if (_.isObject(content) && !_.isArray(content)) {
    content = [content]
  }
  content = (
    <div className='wrap' style={{ maxHeight }}>
      {_.isArray(content) ? content.map((item, idx) => (
        <div className='item' key={idx}>
          {item.title && (<p className='item-title'>{item.title}</p>)}
          {item.content && getContent(item.content)}
        </div>
      )) : content}
    </div>
  )

  return Modal.confirm({
    className: 'mobile-message-box',
    content,
    centered,
    width,
    okText: '我知道了',
    okButtonProps: {
      className: 'ok-botton'
    },
    cancelButtonProps: {
      style: { display: 'none' }
    },
    getContainer,
    maskClosable: true,
    ...options
  })
}

export default showMessageBox
